import { SerializableObject } from './serializable-object';


/** The Auðeknni verification/hash domain object. */
export class AudkenniCode extends SerializableObject {
	verificationCode: string;
	hash: string;
}
